import GrtExampleButtonClass from "./grt-example-button-class";
export default GrtExampleButtonClass;
